import Link from "@mui/material/Link";
import type React from "react";

import { googleMapsUrl } from "@/utils/locationText";

/**
 * Coordinates as a link opening Google Maps at the point in a new tab, in the color of the text around it.
 *
 * A click opens the map without also clicking the row the link sits in. Renders `children` bare when either
 * coordinate is missing.
 */
export function CoordinatesLink({
  latitude,
  longitude,
  testId,
  children,
}: {
  latitude: number | null;
  longitude: number | null;
  testId?: string;
  children: React.ReactNode;
}) {
  if (latitude == null || longitude == null) return <>{children}</>;
  return (
    <Link
      href={googleMapsUrl(latitude, longitude)}
      target="_blank"
      rel="noopener noreferrer"
      color="inherit"
      underline="always"
      data-sb={testId}
      onClick={(event) => event.stopPropagation()}
    >
      {children}
    </Link>
  );
}
